import { useTranslation } from "react-i18next";
import { usePageTitle } from "@/hooks/usePageTitle";
import { ProjectAttachmentsTable } from "./project-attachments-table";
import { useParams } from "react-router-dom";
import type { projectIdKey } from "@/routes/company/routes.projects.constants";
import { withBranding } from "@/utils/helper";

export const TabProjectAttachments = () => {
  const { t } = useTranslation(["projects", "common"]);
  usePageTitle(withBranding(t("projects:project_attachments")));
  const { projectId } = useParams<{ [projectIdKey]: string }>();
  if (!projectId) return t("projects:project_id_not_found");
  return <ProjectAttachmentsTable projectId={projectId} />;
};
